import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function StaticPage() {
    const { slug } = useParams();
    const [page, setPage] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        setPage(null);
        setNotFound(false);
        api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setNotFound(true));
    }, [slug]);

    return (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex flex-col">
            <Navbar />
            <main className="flex-1 container mx-auto px-4 md:px-6 max-w-4xl py-12">
                {notFound ? (
                    <div data-testid="page-not-found" className="text-center py-24">
                        <h1 className="font-display text-3xl font-bold text-slate-900 dark:text-white mb-2">Sayfa bulunamadı</h1>
                        <p className="text-slate-500">Aradığınız sayfa kaldırılmış veya hiç yayınlanmamış olabilir.</p>
                    </div>
                ) : !page ? (
                    <div className="text-slate-500">Yükleniyor...</div>
                ) : (
                    <article data-testid={`static-page-${page.slug}`} className="bg-white dark:bg-slate-900 rounded-2xl p-8 md:p-12 border border-slate-200 dark:border-slate-800 shadow-sm">
                        <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900 dark:text-white mb-6">{page.title}</h1>
                        <div className="prose prose-slate dark:prose-invert max-w-none" dangerouslySetInnerHTML={{ __html: page.content_html || "" }} />
                    </article>
                )}
            </main>
            <Footer />
        </div>
    );
}
